// ******** p_colaborador_novo.jsx *********
// ******** autor: Walcledson de Paula ***
// ******** data: 11/10/24 19h43       ***
// ***************************************

 

import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import apiaxios from "../../../../../Services/apiaxios.js";
import { decrypt } from '../../../../../Services/cryptoUtils.js';
import { AutoLogout } from '../../../../../Services/autologout.js';
import Swal from "sweetalert2";
import { Oval } from 'react-loader-spinner';
import withReactContent from 'sweetalert2-react-content';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';

import Menu from "../../../Components/Menu/p_menu.jsx";
import './p_colaboradores.css';
import { p_getUserData } from '../../../../../Services/p_userutils.js';

function CadastroColaborador() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const navigate = useNavigate();
    // const { state } = useLocation();
    // const [iduser, SetIduser] = useState(state?.iduser || null);
    const initialUserData = p_getUserData();
    const [id_usuario, setIdUsuario] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario

    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    const [formData, setFormData] = useState({
        id_empresa: id_usuario,
        nome: '',
        especialidade: '',
        email: '',
        fone: '',
        percentualComissao: 0
        // percentualcomissao: parseCurrency(formData.percentualcomissao / 100),
        // colaborador_dtcadastro: Date()
    });

    const headers = {
        params: {id_usuario,
                token: tokenASW
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await MySwal.fire({
            title: 'Confirmação!',
            text: "Você confirma os dados deste colaborador?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar!',
            allowOutsideClick: false, // Evita fechamento ao clicar fora
            allowEscapeKey: false // Evita fechamento ao pressionar a tecla "Escape"
        });

        if (result.isConfirmed) {
            try {
                // console.log('antes da api');
                setLoading(true);
                const response = await apiaxios.post('/empresa/colaboradorCrudWeb', formData, headers);
                // console.log('depois da api ', response);

                if (response.status === 201) {
                    MySwal.fire('Sucesso', 'Colaborador cadastrado com sucesso!', 'success');
                    navigate('/app/prestador/empresa/colaboradores');
                } else {
                    MySwal.fire('Erro', 'Falha ao cadastrar colaborador. Tente novamente.', 'error');
                }
            } catch (error) {
                const errorMessage = error.response?.data?.retorno || 'Erro de conexão. Verifique sua conexão e tente novamente.';
                MySwal.fire('Erro', errorMessage, 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    const handleBackClick = () => {
        navigate('/app/prestador/empresa/colaboradores'); // Redireciona para uma página padrão se "from" não estiver definido
    };

    const parseCurrency = (value) => {
        // Garantir que value seja uma string
        if (typeof value !== 'string') {
            // Se não for string, converter para string
            value = String(value);
        }
        // Remover pontos e converter vírgula para ponto
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    };



    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu page="colaboradores" />
                </div>
                <div className="col py-3 me-3">
                    <h1 className="text-center">Cadastrar Novo Colaborador / Funcionário</h1>
                    <hr />
                    {loading && (
                        <div className="loading-spinner-container">
                            <Oval color="#00BFFF" height={80} width={80} />
                        </div>
                    )}

                    <div className="box-perfil">
                        <form onSubmit={handleSubmit}>

                            {/* nome do colaborador */}
                            <div className="row mb-3">
                                <label htmlFor="colaboradornome" className="col-sm-2 col-form-label">Nome</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        id="colaboradornome"
                                        placeholder='Nome do seu colaborador (*)'
                                        autoComplete="address-level2"
                                        type="text"
                                        name="nome"
                                        value={formData.nome}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* especialidade do colaborador */}
                            <div className="row mb-3">
                                <label htmlFor="colaboradorespecialidade" className="col-sm-2 col-form-label">Especialidade</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        id="colaboradorespecialidade"
                                        placeholder='Especialidade (ex.: barbeiro, manicure) (*)'
                                        autoComplete="address-level2"
                                        type="text"
                                        name="especialidade"
                                        value={formData.especialidade}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* email do colaborador */}
                            <div className="row mb-3">
                                <label htmlFor="colaboradoremail" className="col-sm-2 col-form-label">Email</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        id="colaboradoremail"
                                        placeholder='Email do seu colaborador (*)'
                                        autoComplete="address-level2"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* telefone do colaborador */}
                            <div className="row mb-3">
                                <label htmlFor="colaboradorfone" className="col-sm-2 col-form-label">Telefone preferencial</label>
                                <div className="col-sm-10">
                                    <InputMask
                                        mask={"(99)99999-9999"}
                                        // disabled={!isEditable}
                                        type="text"
                                        className="form-control"
                                        id="colaboradorfone"
                                        placeholder="Celular (preferencial WhatsApp) (*)"
                                        autoComplete="address-level2"
                                        name="fone"
                                        value={formData.fone}
                                        onChange={handleInputChange}
                                        required
                                        // ref={foneRef}
                                    />                                    
                                </div>
                            </div>

                            {/* % comissão do colaborador */}
                            <div className="row mb-3">
                                <label htmlFor="colaboradorpercentualComissao" className="col-sm-2 col-form-label">% Comissão</label>
                                <div className="col-sm-10">
                                    <InputMask
                                        mask={"99,99"}
                                        maskChar=""
                                        type="numeric"
                                        name="percentualComissao"
                                        className="form-control"
                                        id="colaboradorpercentualComissao"
                                        placeholder="Comissão (ex: 15.50)"
                                        autoComplete="percentualComissao"
                                        // value={formData.percentualComissao}
                                        value={parseCurrency(formData.percentualComissao)}
                                        onChange={handleInputChange}
                                        step="0.01" // permite até duas casas decimais
                                        min="0"
                                        max="100"
                                    />                                    
                                </div>
                            </div>

                            <div className='text-center'>
                                <button className='btn btn-primary me-2' type="submit">Cadastrar Colaborador</button>
                                <button className="btn btn-secondary" onClick={handleBackClick}>
                                    <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Cancelar'}
                                </button>
                            </div>
                        </form>
                    </div>
                    <p className="text-sm text-right">(*) campos obrigatórios.</p>
                </div>
            </div>
        </div>
    );
}

export default CadastroColaborador;